import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React,{Component} from 'react';
import firebase from 'firebase';
import {Link} from 'react-router-dom';
import store from '../../store';

const database=firebase.database();


class ReporteConductores extends Component{
	
	
	constructor(props){
		
		super(props)
		
		this.state={
			conductores:[],
			conductorestemp:[],
			socios:[],
			vehiculos:[],
			labels:['Nombre','Dui','Licencia','Socio','Estado','Vehiculo']
			
		}
		
		
		this.handleFilter=this.handleFilter.bind(this);
		this.changeStatePrint=this.changeStatePrint.bind(this);
		this.handleClickPrint=this.handleClickPrint.bind(this);
		
		this.conductoresRef=database.ref().child('Empleados');
		this.sociosRef=database.ref().child('Socios');
		this.vehiculosRef=database.ref().child('Vehiculos');
	}
	
	
	
	componentDidMount(){
	
		this.sociosRef.on('value',this.gotDataSocios,this.errDataSocios);		
		
		
	}
	componentWillMount(){
		
		this.sociosRef.on('value',this.gotDataSocios,this.errDataSocios);		
		
		
	}
	
	
	
	
	
	gotDataSocios=(data)=>{
		
		
		
		let newSocios=[];
		
		if(data.val()!==null){
			
			let socio=data.val();
			let keys=Object.keys(socio);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
								
				if(socio[k].Nombre!==undefined){
					
					newSocios.push({
						key:k,
						nombre:socio[k].Nombre,
						apellido:socio[k].Apellido,
						estado:socio[k].Estado						
					})
				}
				
			}
			this.setState({socios:newSocios});			
			this.vehiculosRef.on('value',this.gotDataVehiculos,this.errDataVehiculos);
		}		
	}
	errDataSocios=(err)=>{
		
		console.log(err);
		
	}
	
	
	gotDataVehiculos=(data)=>{
		
		let newVehiculos=[]
		
		
		if(data.val()!==null){
			
			
			let vehiculo=data.val();
			
			let keys=Object.keys(vehiculo);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				if(vehiculo[k].marca!==undefined){
		
					
		
					newVehiculos.push({
						key:k,
						base:vehiculo[k].base,
						marca:vehiculo[k].marca,
						modelo:vehiculo[k].modelo,
						estado:vehiculo[k].estado,
						socio:vehiculo[k].codigo_socio,
						anio:vehiculo[k].anio,
						placa:vehiculo[k].placa,
						tipo_vehiculo:vehiculo[k].tipo_vehiculo						
					})
			
				}
				
			}
			this.setState({vehiculos:newVehiculos});
			
			this.conductoresRef.on('value',this.gotData,this.errData);	
			
		}
		
		
		
	}
	errDataVehiculos=(err)=>{
		
		
		console.log(err);
		
	}
	
	
	gotData=(data)=>{
		
		
		let newConductores=[]
		
		
		if(data.val()!=null){
			
			let data_conductores=data.val();
			let keys=Object.keys(data_conductores);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				
				
				if(data_conductores[k].nombre!==undefined){
				
					let vehiculo_nombre;
					let socio_nombre;
				
					for(let j=0;j<this.state.socios.length;j++){
						
						if(data_conductores[k].socio===this.state.socios[j].key){
							
							socio_nombre=this.state.socios[j].nombre+' '+this.state.socios[j].apellido;
						}
						
					}
					
		
					for(let h=0;h<this.state.vehiculos.length;h++){
						
						
						if(data_conductores[k].vehiculo===this.state.vehiculos[h].key){
							
							
							vehiculo_nombre=this.state.vehiculos[h].marca+' '+this.state.vehiculos[h].modelo;
							
						}
		
						
						
					}
					
					
					newConductores.push({
						key:k,
						nombre:data_conductores[k].nombre,
						correo:data_conductores[k].correo,
						direccion:data_conductores[k].direccion, 
						dui:data_conductores[k].dui,
						licencia:data_conductores[k].licencia,
						edad:data_conductores[k].edad,
						estado:data_conductores[k].estado,
						socio:socio_nombre,
						vehiculo:vehiculo_nombre
					})				
					
				}
				
				
				
			}
			this.setState({
				conductores:newConductores,
				conductorestemp:newConductores			
			});
					
		}
		
		
	}
	errData=(err)=>{
		
		console.log(err);
		
	}
	
	
	handleFilter(){
		
		
		let newConductores=[]
		
		let socio=this.socios.value;
		let estado=this.estado.value;
		
		
		
		
		this.state.conductores=this.state.conductorestemp
		
		
		for(let i=0;i<this.state.conductores.length;i++){
			
			
			
			
			
			let nombre_socio=this.state.conductores[i].socio.toLowerCase().search(socio.toLowerCase())>=0?true:false;
			let estado_socio=this.state.conductores[i].estado.toLowerCase().search(estado.toLowerCase())>=0?true:false;
			
			
			
			
			
			
			
			if(nombre_socio && estado_socio){
				
				
				newConductores.push({
					
						key:this.state.conductores[i].key,
						nombre:this.state.conductores[i].nombre,
						correo:this.state.conductores[i].correo,
						direccion:this.state.conductores[i].direccion, 
						dui:this.state.conductores[i].dui,
						licencia:this.state.conductores[i].licencia,
						edad:this.state.conductores[i].edad,
						estado:this.state.conductores[i].estado,
						socio:this.state.conductores[i].socio,
						vehiculo:this.state.conductores[i].vehiculo
										
				})
				
							
			}
			
			
		}
		
		this.state.conductores=newConductores;
		this.setState({conductores:newConductores})
		
		
	}
	
	handleClickPrint(){
		
		this.changeStatePrint();

	}
	
	changeStatePrint(){
		
	
		
		store.dispatch({
			
			type: "STATE_REPORT",
			labels_report:this.state.labels,
			data_report:this.state.conductores,
			tipo_reporte:'reporte_conductores'
		})
		
		
	}
	
	
	render(){
		
		
			return(
			
			
					<div className="reporte_conductores">
			
						<center><h3>Reporte de conductores</h3></center>
						
						
						
						
						<div className="row">
							<div class="col-md-4">
								<Link to="template" className="btn btn-success" onClick={this.handleClickPrint}><span class="glyphicon glyphicon-print"> Imprimir</span></Link>
							</div>							
							<div class="col-md-4">
								<div className="form-group">
									<label htmlFor="socio">Socio</label>
									<input type="text" name="socio" placeholder="Socio" className="form-control"
									ref={input=>{this.socios=input}}
									onKeyUp={this.handleFilter}
									/>
								</div>						
							</div>
							<div class="col-md-4">
								<div className="form-group">
									<label htmlFor="estado">Estado</label>
									<input type="text" className="form-control" placeholder="Estado" name="estado"
									ref={input=>{this.estado=input}}
									onKeyUp={this.handleFilter}
									/>
								</div>
							</div>
							
						</div>
									
						<BootstrapTable data={ this.state.conductores }
								 ref='table'			 
								 pagination={ true }
								 search={ false }
								 hover
								 >
								 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
								 <TableHeaderColumn dataField='nombre'  dataSort={true}  >Nombre</TableHeaderColumn>
								 <TableHeaderColumn dataField='dui'  dataSort={true}  >Dui</TableHeaderColumn>
								 <TableHeaderColumn dataField='licencia'  dataSort={true}  >Licencia</TableHeaderColumn>
								 <TableHeaderColumn dataField='correo'  dataSort={true}  >Correo</TableHeaderColumn>
								 <TableHeaderColumn dataField='edad'  dataSort={true}  >Edad</TableHeaderColumn>
								 <TableHeaderColumn dataField='socio'  dataSort={true}  >Socio</TableHeaderColumn>
								 <TableHeaderColumn dataField='estado'  dataSort={true}  >Estado</TableHeaderColumn>
								 <TableHeaderColumn dataField='vehiculo'  dataSort={true}  >Vehiculo</TableHeaderColumn>				
						</BootstrapTable>
						


			
				
					</div>
			)
		
		
	}
	
}

export default ReporteConductores;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteConductores.jsx